<template>
  <div>
    <alert
      :variant="alert.variant"
      dismissible
      :mensagens="alert.mensagens"
      :value="alert.exibir"
      @input="alertDismissed"
    >
    </alert>
    <b-card no-body class="p-1">
      <b-row>
        <b-col class="col-12 col-md-4">
          <label class="font-weight-bold">Edição:</label
          ><label class="ml-1">{{ edicao.numero_edicao }}</label>
        </b-col>
        <b-col class="col-12 col-md-4">
          <label class="font-weight-bold">Tipo Edição:</label
          ><label class="ml-1">{{
            $helper.getTipoEdicao(edicao.tipo_edicao)
          }}</label>
        </b-col>
        <b-col class="col-12 col-md-4">
          <label class="font-weight-bold">Data Publicação:</label
          ><label class="ml-1">
            {{ $helper.formatData(edicao.dt_publicacao) }}</label
          >
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mt-2">
      <b-row>
        <b-col class="col-12 col-md-3">
          <b-form-group label="Categoria" label-size="sm">
            <b-form-select
              id="categoria"
              v-model="filtro.categoria_ato_id"
              :options="categoriaAto.options"
            >
              <template v-slot:first>
                <b-form-select-option :value="null"></b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col class="col-12 col-md-4">
          <b-form-group label="Título" label-size="sm">
            <b-input-group>
              <b-form-input id="titulo" v-model="filtro.titulo_ato">
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="col-12 col-md-5">
          <b-form-group label="Órgão" label-size="sm">
            <autocomplete
              :function="buscarOrgaos"
              key-text="sigla_nome_orgao"
              key-id="id"
              :active-first="false"
              v-model="sigla_nome_orgao"
              :allow-any="false"
              :min-search-size="2"
              @selected="selecionaOrgao"
              size="sm"
              ref="autocompleteorgao"
              id="orgao"
              placeholder="Informe a sigla ou nome do órgão que deseja pesquisar"
            >
            </autocomplete>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="">
        <b-col class="text-right">
          <b-btn
            class="col-sm-12 col-md-auto"
            variant="primary"
            @click="listar"
            size="sm"
          >
            <i class="fa fa-search pr-1"></i> Pesquisar
          </b-btn>
        </b-col>
      </b-row>
    </b-card>

    <b-row class="mb-2 mt-3">
      <b-col class="text-right">
        <b-btn
          class="col-sm-12 col-md-auto"
          size="sm"
          variant="outline-secondary"
          @click="incluir"
          v-if="acao != 'view'"
        >
          <i class="fa fa-file-o pr-1"></i> Novo Ato
        </b-btn>
      </b-col>
    </b-row>

    <b-row class="mx-0">
      <b-table
        no-provider-paging
        small
        responsive
        :current-page="tabela.currentPage"
        :empty-text="tabela.emptyText"
        :fields="tabela.fields"
        :items="tabela.items"
        :per-page="tabela.perPage"
        :show-empty="tabela.showEmpty"
        :striped="tabela.striped"
        :fixed="tabela.fixed"
      >

        <template v-slot:cell(dt_atualizacao)="data">
          {{ $helper.formatDataHoraMinutoSegundo(data.value) }}
        </template>

        <template v-slot:cell(anexos_count)="data">
          {{ possuiAnexos(data.item.anexos_count) }}
        </template>

        <template v-slot:cell(ver)="data">
          <i class="fa fa-eye fa-lg" @click="visualizar(data.item)"></i>
        </template>

        <template v-slot:cell(editar)="data">
          <i
            class="fa fa-pencil fa-lg"
            @click="editar(data.item)"
            v-if="acao != 'view'"
          ></i>
        </template>

        <template v-slot:cell(excluir)="data">
          <i
            class="fa fa-trash fa-lg"
            @click="excluir(data.item)"
            v-if="acao != 'view'"
          ></i>
        </template>
      </b-table>
    </b-row>
    <b-row align-h="end">
      <b-col class="col-12 col-md-4">
        <b-form-group
          label-cols="8"
          label="Itens por página:"
          label-align="right"
          label-size="sm"
          label-class="mt-1 text-secondary"
        >
          <b-form-select
            v-model="tabela.perPage"
            size="sm"
            :options="tabela.pageOptions"
            @change="tabela.currentPage = 1"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col class="col-md-3">
        <b-pagination
          v-show="tabela.totalRows > tabela.perPage"
          align="right"
          :total-rows="tabela.totalRows"
          :per-page="tabela.perPage"
          :value="tabela.currentPage"
          @change="mudaPagina"
          class="mt-2"
          size="sm"
        >
        </b-pagination>
      </b-col>
    </b-row>

    <atoForm    
      v-if="exibirModal"      
      :edicao="edicao"
      :idAto="atoSelecionado.id"
      :exibirModal.sync="exibirModal"
      :acao="action"
    >
    </atoForm>
  </div>
</template>

<script>
import Alert from "../../../models/Alert";
import atoForm from "./atoForm";
import moment from "moment";
import sjcl from 'sjcl';
import autocomplete from "../../../components/Autocomplete";
import Ato from "../../../models/Ato";
import Edicao from "../../../models/Edicao";


export default {
  components: {
    atoForm,
    autocomplete,
  },

  props: {
    acao: { type: String, default: "" },
    edicao: { type: Edicao },
  },

  data() {
    return {
      atoSelecionado: new Ato(),
      exibirModal: false,
      tabela: {
        currentPage: 1,
        emptyText: "Nenhum registro encontrado",
        fields: [
          {
            key: "categoria.nome_categoria",
            label: "Categoria",
            sortable: true,
            thStyle: "width:100px",
          },
          {
            key: "titulo_ato",
            label: "Título",
            sortable: true,
            thStyle: "width:400px",
          },
          {
            key: "orgao.sigla_orgao",
            label: "Órgão",
            sortable: true,
            thStyle: "width:100px",
          },
          {
            key: "publicacao",
            label: "Publicação",
            class: "text-center",
            sortable: true,
            thStyle: "width:100px",
          },

          {
            key: "anexos_count",
            label: "Anexos",
            sortable: true,
            class: "text-center",
            thStyle: "width:100px",
          },
          {
            key: "dt_atualizacao",
            label: "Última atualização",
            sortable: true,
            thStyle: "width:150px",
          },
          {
            key: "ver",
            label: "",
            class: "text-center",
          },
          {
            key: "editar",
            label: "",
            class: "text-center",
          },
          {
            key: "excluir",
            label: "",
            class: "text-center",
          },
        ],
        items: [],
        perPage: 10,
        showEmpty: true,
        striped: true,
        fixed: false,
        totalRows: 0,
        pageOptions: [10, 25, 50, 100],
      },
      action: this.acao,
      alert: new Alert(),
      filtro: {
        titulo_ato: "",
        categoria_ato_id: "",
        orgao_id: "",
      },
      categoriaAto: {
        options: [],
      },
      sigla_nome_orgao: "",
    };
  },

  methods: {
    alertDismissed() {
      this.alert = new Alert();
    },

    visualizar(ato) {
      this.atoSelecionado = ato;
      this.exibirModal = true;
      this.action = "view";
    },

    editar(ato) {
      this.atoSelecionado = ato;
      this.exibirModal = true;
      this.action = "edit";
    },

    excluir(ato) {
      let tipoEdicao = this.$helper.getTipoEdicao(this.edicao.tipo_edicao);
      let message = `Confirma a exclusão do ato "${ato.titulo_ato}" da Edição 
                            ${this.edicao.numero_edicao} - ${tipoEdicao} 
                            de ${moment(this.edicao.dt_publicacao).format(
                              "DD/MM/YYYY"
                            )} - ${this.edicao.hr_publicacao}?`;

      this.$helper.confirmaExclusao(this, message).then((value) => {
        if (value) {
          this.$api.ato.excluir(ato.id)
            .then((response) => {
              if (response.status == 200 || response.status == 201) {
                this.$helper.showAlert(
                  this.alert,
                  this.$constantes.alert.variants.SUCCESS,
                  "Registro excluído com sucesso!"
                );
                this.listar();
              }
            })
            .catch((error) => {
              this.$helper.showAlert(
                this.alert,
                this.$constantes.alert.variants.DANGER,
                error.response.data.errors
              );
          });

          this.$helper.scrollWindowToTop();
        }
      });
    },

    incluir() {
      this.exibirModal = true;
      this.action = "new";
    },

    existeAtoPublicacaoPendente() {
      return this.tabela.items.some(ato => ato.publicacao === this.$constantes.ato.publicacao.PENDENTE);
    },

    existeAtoParaRepublicar() {
      return this.tabela.items.some(ato => ato.publicacao === this.$constantes.ato.publicacao.REPUBLICAR);
    },

    setPublicacao(ato) {      
      if(ato.documento_ato.nome_minio){                 
        const myBitArray = sjcl.hash.sha256.hash(ato.conteudo_html);   
        const hashConteudoHtml = sjcl.codec.hex.fromBits(myBitArray);
        if(hashConteudoHtml === ato.documento_ato.hash_arquivo){
          ato.publicacao = this.$constantes.ato.publicacao.OK;
        }else{
          ato.publicacao = this.$constantes.ato.publicacao.REPUBLICAR;         
        }
      }else{
        ato.publicacao = this.$constantes.ato.publicacao.PENDENTE;        
      } 
    },

    listar() {
      this.sigla_nome_orgao == ""
        ? (this.filtro.orgao_id = "")
        : this.filtro.orgao_id;
      this.$api.ato.listar(this.filtro, this.edicao.id)
        .then((response) => {
          this.tabela.items = [];
          response.data.data.forEach((element) => {
            let ato = new Ato(element);            
            this.setPublicacao(ato);
            this.tabela.items.push(ato);
          });          
          this.tabela.totalRows = response.data.data.length;          
          this.mudaPagina(1);
          this.$emit('aposListar', this.existeAtoPublicacaoPendente(), this.existeAtoParaRepublicar());
        })
        .catch((error) => {
          this.$helper.showAlert(
            this.alert,
            this.$constantes.alert.variants.DANGER,
            error.response.data.errors
          );
        });
    },

    mudaPagina(pagina) {
      this.tabela.currentPage = pagina;
    },


    possuiAnexos(anexos_count) {
      return anexos_count > 0 ? "Sim" : "Não";
    },

    buscarCategoriasAto() {
      let params = {
        ind_ativo: true,
      };

      this.$api.categoriaAto
        .listar(params)
        .then((response) => {
          this.categoriaAto.options = [];

          response.data.data.forEach((element) => {
            let option = {
              value: element.id,
              text: element.nome_categoria,
              disabled: !element.ind_ativo,
            };

            this.categoriaAto.options.push(option);
          });
        })
        .catch((error) => {
          this.$helper.showAlert(
            this.alert,
            this.$constantes.alert.variants.DANGER,
            error.response.data.errors
          );
        });
    },

    buscarOrgaos(siglaNome) {
      let parametros = {
        sigla_nome: siglaNome,
        ind_favorito_dom: true,
      };

      return this.$api.orgao.buscar(parametros).then((response) => {
        response.data.data.forEach((element) => {
          element.sigla_nome_orgao =
            element.sigla_orgao + " - " + element.nome_orgao;
        });

        return response;
      });
    },

    selecionaOrgao(orgao) {
      this.filtro.orgao_id = orgao.id;
      this.sigla_nome_orgao = orgao.sigla_nome_orgao;
    },
  },

  mounted() {
    if (this.edicao.id != null) {
      this.listar();
      this.buscarCategoriasAto();
    }
  },

  watch: {
    exibirModal: function () {
      if (!this.exibirModal) {
        this.listar();
      }
    },
  },
};
</script>

